import getUseStyles from "@styles/getUseStyles";
import { CustomStylePropsInterface } from "types/styleType";

export const useStyles = (styles?: any, withCommonStyle = true, custom?: CustomStylePropsInterface) => {
	return getUseStyles(styles, withCommonStyle, custom)();
};

export default useStyles;
